import React from "react";
import { useTranslation } from "react-i18next";
import { Typography } from "@material-ui/core";

const PageNotFound = () => {
    const { t } = useTranslation();

    return (
        <Typography>{t("PageNotFound.body")}</Typography>
    );
}

export default PageNotFound;
